export default "__VITE_ASSET__66f3466e__"